import { FeedbackTab } from '@chegg-wt/core/constants/paraphraser'
import {
  ChangeType,
  Feedback,
  FeedbackType,
  QuickActionPanelType,
} from '@chegg-wt/core/types/paraphraser'
import { Dispatch, SetStateAction } from 'react'

export interface SentenceOffset {
  id: string
  offset: number
  length: number
  originalText: string // local variable only, will not be stored in db
  lastUpdated: number
}

export enum ToastType {
  FLAG = 'flag',
  COPY = 'copy',
  GRAMMAR_ERROR = 'grammar:error',
  CLARITY_ERROR = 'clarity:error',
  QUICK_ACTION_RETRY_ERROR = 'quickActionRetryError:error',
}

export interface ParaphraserState {
  paraphraseFlag: boolean
  sentenceOffsets: SentenceOffset[]
  feedbackList: Feedback[]
  fetchNewSentencesLoading: boolean
  isPaperCheckInProgress: boolean
  rewritePanelSentences: SentenceOffset[]
  quickActionPanelType: QuickActionPanelType | null
  activeFeedbackTab: FeedbackTab
  activeFeedbackCardId: string | null
  isTimedOut: boolean
  totalFeedbackCount: number
  paperId?: string
  paperTitle: string
  requiresReCheck: boolean // Using the same name as in DB
  wordCount: number
  toastType: ToastType | null
  writingAssistantHomeFlag: boolean
  enabledWritingAssistantFeatures: WAFeatures
}

interface PusherGrammarSuggestions {
  id: string
  reason: string
  changeType: ChangeType
  position: {
    offset: number
    length: number
  }
  suggestedText: string
}

export interface PusherGrammarFeedback {
  // for grammar only
  suggestions: PusherGrammarSuggestions[]
  feedbackType: FeedbackType.GRAMMAR
}
export interface PusherParaphraseFeedback {
  id: string
  score: number
  suggestedText: string
  feedbackType: FeedbackType.PARAPHRASE
}

export interface PusherSynonymsFeedback {
  feedbackType: FeedbackType.SYNONYM
  position: {
    offset: number
    length: number
  }
  synonyms: string[]
}

export type ErrorData = {
  code: string
  message: string
}

export type WtPusherEvent<
  K = PusherGrammarFeedback | PusherParaphraseFeedback | PusherSynonymsFeedback
> = {
  sentence: { id: string; originalText: string }
  initiatedAt: string
  checkType: any
  feedback: K
  error?: ErrorData
}

export enum ProofReaderCardActions {
  ACCEPT = 'accept',
  REJECT = 'reject',
  CLICK = 'click',
  REGENERATE = 'regenerate',
  FLAG = 'flag',
}

export type SetError = Dispatch<SetStateAction<ErrorData>>
export type SetIsLoadingSuggestions = Dispatch<SetStateAction<boolean>>
export type SetIsLoading = Dispatch<SetStateAction<boolean>>

// enabled WritingAssistantFeatures for 100 percent release
export type WAFeatures = {
  // quick actions
  expand: boolean
  shorten: boolean

  // features
  redoUndo: boolean
  reasonOnClarityCard: boolean
  draftQuickActions: boolean
}
